import { WEIGHT_WARNING_FACTOR, WEIGHT_BLOCK_FACTOR } from '@/views/PesosCocidos/cookedWeightsConstants'

export const WEIGHT_LEVEL = {
  NORMAL: 'normal',
  HIGH: 'high',
  IMPOSSIBLE: 'impossible'
}

export function classifyWeight (grams, minimumGrams) {
  if (minimumGrams <= 0) {
    return WEIGHT_LEVEL.NORMAL
  }
  if (grams > minimumGrams * WEIGHT_BLOCK_FACTOR) {
    return WEIGHT_LEVEL.IMPOSSIBLE
  }
  if (grams > minimumGrams * WEIGHT_WARNING_FACTOR) {
    return WEIGHT_LEVEL.HIGH
  }
  return WEIGHT_LEVEL.NORMAL
}
